import { getExperiencePriceCategoryLabel } from '@/lib/experience/price-category-label'

export function useExperiencePriceCategoryName() {
  return getExperiencePriceCategoryLabel
}
